import { Component, Input } from "@angular/core";
import { AdminStatusHistoryModel } from "@models/adminStatusHistory.model";
import { ItemStatusHistoryModel } from "@models/itemStatusHistory.model";
import { OrderStatus, OrderStatusNext } from "@models/order.model";

@Component({
    selector: "app-order-timeline",
    templateUrl: "./order-timeline.component.html",
    styleUrls: ["./order-timeline.component.scss"],
    standalone: false,
})
export class OrderTimelineComponent {
    orderStatuses: { status: string; color: string; time?: Date }[] = [];
    @Input() statusHistory: AdminStatusHistoryModel[] | ItemStatusHistoryModel[] = [];
    public OrderStatus = OrderStatus;

    ngOnChanges() {
        this.orderStatuses = [];
        this.initializeOrderStatuses();
    }

    private initializeOrderStatuses(): void {
        this.orderStatuses = [];

        const sortedHistory = [...this.statusHistory].reverse(); // oldest → latest

        for (const history of sortedHistory) {
            this.orderStatuses.push({
            status: history.status,
            color: "green",
            time: history.createdAt
            });
        }

        const lastStatus = sortedHistory.at(-1)?.status;
        const nextStatus = this.getNextStatus(lastStatus!);

        if (nextStatus) {
            this.orderStatuses.push({ status: nextStatus, color: "grey" });
        }
    }

    private getNextStatus(status: string): string {
        switch (status) {
            case OrderStatus.Ordered:
                return OrderStatusNext.Ordered;
            case OrderStatus.Packed:
                return OrderStatusNext.Packed;
            case OrderStatus.Dispatched:
                return OrderStatusNext.Dispatched;
            case OrderStatus.Delivered:
                return OrderStatusNext.Delivered;
            case OrderStatus.ExchangeInitiated:
                return OrderStatusNext.ExchangePacked;
            case OrderStatus.ExchangePacked:
                return OrderStatusNext.ExchangeDispatched;
            case OrderStatus.ExchangeDispatched:
                return OrderStatusNext.Exchanged;
            case OrderStatus.ReturnInitiated:
                return OrderStatusNext.ReturnInitiated;
            case OrderStatus.PickupScheduled:
                return OrderStatusNext.PickupScheduled;
            case OrderStatus.Returned:
                return OrderStatusNext.Returned;
            default:
                return "";
        }
    }
}
